import {
  stringLatinCharactersAndQuotes,
  validatePhoneNumber,
  email,
} from '../../../../../Utils/Validators/formValidation'

export const allowedExtensions = ['jpg', 'jpeg', 'png']
export const maxFileSize = 5 * 1024 * 1024 // 5MB in bytes
export const maxImageWidth = 1000
export const maxImageHeight = 1000

export const PROFILE_FORM_INPUTS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  PHONE: 'mobilePhone',
  EMAIL: 'email',
  PICTURE: 'profilePicture',
  ROLE: 'role',
}

export const requiredFields = [
  PROFILE_FORM_INPUTS.FIRST_NAME,
  PROFILE_FORM_INPUTS.LAST_NAME,
  PROFILE_FORM_INPUTS.PHONE,
]

const NAME_FIELDS = {
  [PROFILE_FORM_INPUTS.FIRST_NAME]: 'First name',
  [PROFILE_FORM_INPUTS.LAST_NAME]: 'Last name',
}

export const validateUserProfile = (e, setErrors, errors) => {
  if (!e || !e.target.name || !e.target.value) {
    return
  } else if (
    [PROFILE_FORM_INPUTS.FIRST_NAME, PROFILE_FORM_INPUTS.LAST_NAME].includes(
      e.target.name,
    )
  ) {
    setErrors({
      ...errors,
      [e.target.name]:
        stringLatinCharactersAndQuotes(e.target.value) ||
        (e.target.value.length < 2
          ? `${NAME_FIELDS[e.target.name]} must contain at least 2 letters`
          : undefined),
    })
  } else if ([PROFILE_FORM_INPUTS.PHONE].includes(e.target.name)) {
    setErrors({
      ...errors,
      [e.target.name]: validatePhoneNumber(e.target.value),
    })
  } else if ([PROFILE_FORM_INPUTS.EMAIL].includes(e.target.name)) {
    setErrors({ ...errors, [e.target.name]: email(e.target.value) })
  }
}

export const handleImageUpdate = ({
  event,
  setUserData,
  userData,
  setProfilePicture,
}) => {
  const fileUploaded = event.target.files[0]

  if (fileUploaded) {
    const fileExtension = fileUploaded.name
      .split('.')
      .pop()
      .toLowerCase()
    const isValidExtension = allowedExtensions.includes(fileExtension)

    if (!isValidExtension) {
      alert('Invalid file extension')
      return
    }

    if (fileUploaded.size > maxFileSize) {
      alert('File size exceeds the limit of 5MB.')
      return
    }

    const img = new Image()
    const objectUrl = URL.createObjectURL(fileUploaded)

    img.onload = function() {
      if (this.width > maxImageWidth || this.height > maxImageHeight) {
        alert('Image size exceeds the limit of 1000 x 1000px.')
        return
      }

      setUserData({ ...userData, [PROFILE_FORM_INPUTS.PICTURE]: fileUploaded })
      setProfilePicture(objectUrl)
    }
    img.src = objectUrl
  }
}
